import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import ProfileDetails from "./tabs-content/ProfileDetails";
import Security from "./tabs-content/Security";
import AppSettings from "./tabs-content/AppSettings";
import { SettingsTabs } from "../../..";
const SETTINGS_TABS_LABEL = [{
  label: "Profile Details"
}, {
  label: "Security"
}, {
  label: "App Settings"
}];
const ManagerSettingsScreen = ({
  timeZoneDisabled = false,
  appSettingsItems = []
}) => {
  const SETTINGS_TAB = [/*#__PURE__*/React.createElement(ProfileDetails, {
    key: 0
  }), /*#__PURE__*/React.createElement(Security, {
    key: 1
  }), /*#__PURE__*/React.createElement(AppSettings, {
    key: 2,
    timeZoneDisabled: timeZoneDisabled,
    items: appSettingsItems
  })];
  return /*#__PURE__*/React.createElement(SettingsTabs, {
    tabsLabels: SETTINGS_TABS_LABEL,
    tabsContent: SETTINGS_TAB
  });
};
export default ManagerSettingsScreen;
ManagerSettingsScreen.propTypes = {
  timeZoneDisabled: PropTypes.bool,
  appSettingsItems: PropTypes.array
};